import Calc from "@/common/util/calculator"
import Form from "./base"
import PathObject from "../objects/path"
import type { DrawableMixin } from "../objects/drawable_mixin"

export default class EllipseForm extends Form {
  protected path(width: number, height: number) {
    const commands = this.commands(width, height)

    return new PathObject(commands.join(""), this.defaultParams)
  }

  protected commands(width: number, height: number) {
    const startY = -(height / 2)
    const rx = width / 2
    const ry = height / 2

    const commands = [this.pathMoveTo(0, startY)]

    commands.push(this.pathArcAbs(rx, ry, width / 2, 0))
    commands.push(this.pathArcAbs(rx, ry, 0, height / 2))
    commands.push(this.pathArcAbs(rx, ry, -(width / 2), 0))
    commands.push(this.pathArcAbs(rx, ry, 0, startY))
    commands.push(this.pathClose())

    return commands
  }

  protected snappablePaths(width: number, height: number): [DrawableMixin, DrawableMixin] {
    const gap = Calc.mmToPx(3)
    const rx = width / 2
    const ry = height / 2

    if (width > height) {
      const side = [
        this.pathMoveTo(-(gap / 2), height / 2),
        this.pathArcAbs(rx, ry, gap / 2, height / 2, false), // B
        this.pathMoveTo(gap / 2, -(height / 2)),
        this.pathArcAbs(rx, ry, -(gap / 2), -(height / 2), false),
      ]

      const rest = [
        this.pathMoveTo(-(width / 2), 0),
        this.pathArcAbs(rx, ry, -(gap / 2), height / 2, false), // BL
        this.pathMoveTo(gap / 2, height / 2),
        this.pathArcAbs(rx, ry, width / 2, 0, false), // BR
        this.pathArcAbs(rx, ry, gap / 2, -(height / 2), false), // TR
        this.pathMoveTo(-(gap / 2), -(height / 2)),
        this.pathArcAbs(rx, ry, -(width / 2), 0, false), // TL
      ]

      return [new PathObject(side.join(""), this.defaultParams), new PathObject(rest.join(""), this.defaultParams)]
    }

    const side = [
      this.pathMoveTo(-(width / 2), -(gap / 2)),
      this.pathArcAbs(rx, ry, -(width / 2), gap / 2, false), // L
      this.pathMoveTo(width / 2, gap / 2),
      this.pathArcAbs(rx, ry, width / 2, -(gap / 2), false), // R
    ]

    const rest = [
      this.pathMoveTo(-(width / 2), gap / 2),
      this.pathArcAbs(rx, ry, 0, height / 2, false), // BL
      this.pathArcAbs(rx, ry, width / 2, gap / 2, false), // BR
      this.pathMoveTo(width / 2, -(gap / 2)),
      this.pathArcAbs(rx, ry, 0, -(height / 2), false), // TR
      this.pathArcAbs(rx, ry, -(width / 2), -(gap / 2), false), // TL
    ]

    return [new PathObject(side.join(""), this.defaultParams), new PathObject(rest.join(""), this.defaultParams)]
  }
}
